import { render } from "./FlashSaleComponent.vue?vue&type=template&id=5e744084"
import script from "./FlashSaleComponent.vue?vue&type=script&lang=js"
export * from "./FlashSaleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/FlashSaleComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e744084"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e744084', __exports__)) {
    api.reload('5e744084', __exports__)
  }
  
  module.hot.accept("./FlashSaleComponent.vue?vue&type=template&id=5e744084", () => {
    api.rerender('5e744084', render)
  })

}


export default __exports__